import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { initAnalytics } from "./lib/analytics";

// Both no-op unless their env vars (VITE_SENTRY_DSN / VITE_PLAUSIBLE_DOMAIN)
// are configured, so this is safe in every environment.
initSentry();
initAnalytics();

const rootElement = document.getElementById("root");
if (rootElement && !rootElement.hasAttribute('data-root-created')) {
  rootElement.setAttribute('data-root-created', 'true');
  createRoot(rootElement).render(<App />);
}
